import { defer } from "react-router-dom";

import { MissingAccountError } from "@/modules/errors";
import { accountsQuery } from "@/services/lukita/queries";

export const appLoader = async () => {
  const account = accountsQuery().then(({ accounts }) => {
    if (accounts.length === 0) throw new MissingAccountError();
    return accounts[0];
  });

  return defer({ account });
};
